/**
 * Browser detection utilities for Safari/iOS-specific handling
 */

/**
 * Detect if the browser is Safari (desktop or iOS)
 * Excludes Chrome and Android browsers that may contain "Safari" in user agent
 */
export const isSafari = (): boolean => {
  const ua = navigator.userAgent;
  // Safari detection: has Safari in UA but NOT Chrome or Android
  return /^((?!chrome|android).)*safari/i.test(ua);
};

/**
 * Detect if the browser is running on iOS (iPhone/iPad)
 */
export const isIOS = (): boolean => {
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || 
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPad with "Desktop mode"
};

/**
 * Detect if the browser is Safari on iOS
 */
export const isSafariIOS = (): boolean => {
  return isSafari() && isIOS();
};

/**
 * Check if browser requires explicit user gesture for getUserMedia
 * Safari/iOS require user interaction, Chrome/Firefox allow programmatic access
 */
export const requiresUserGestureForMicrophone = (): boolean => {
  return isSafari() || isIOS();
};

/**
 * Get browser name for logging
 */
export const getBrowserName = (): string => {
  const ua = navigator.userAgent;
  
  if (isSafariIOS()) return 'Safari iOS';
  if (isSafari()) return 'Safari';
  if (/chrome|crios|crmo/i.test(ua)) return 'Chrome';
  if (/firefox|fxios/i.test(ua)) return 'Firefox';
  if (/edg/i.test(ua)) return 'Edge';
  
  return 'Unknown';
};
